import React, { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../constants/Theme';

export type Evaluation = 'neutral' | 'negative' | 'positive';

interface TagsProps {
  children: ReactNode;
  evaluation: Evaluation;
}

const HearingDescriptionTag: React.FC<TagsProps> = ({ children, evaluation }) => {
  const classes = useStyles();
  let containerClasses: string;

  switch (evaluation) {
    case 'neutral':
      containerClasses = `${classes.container} ${classes.tagNeutral}`;
      break;
    case 'negative':
      containerClasses = `${classes.container} ${classes.tagNegative}`;
      break;
    case 'positive':
      containerClasses = `${classes.container} ${classes.tagPositive}`;
      break;
    default:
      containerClasses = `${classes.container} ${classes.tagNeutral}`;
  }

  return (
    <div className={containerClasses}>
      <div className={classes.label}>{children}</div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    width: 'fit-content',
    position: 'relative',
    borderRadius: 40,
    boxSizing: 'border-box',
    overflow: 'hidden',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3px 7px',
    fontSize: '12px',
    color: theme.colors.contrastBlack,
    fontFamily: theme.typography.fontFamily,
  },
  label: {
    position: 'relative',
    letterSpacing: 0.3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tagNegative: {
    backgroundColor: theme.colors.functionalRedLight,
    border: '1px solid',
    borderColor: theme.colors.roseMain,
  },
  tagNeutral: {
    backgroundColor: theme.colors.functionalYellowLight,
  },
  tagPositive: {
    backgroundColor: theme.colors.functionalGreenLight,
  },
});

export default HearingDescriptionTag;
